<template>
  <div>
    <div
      class="label cursor-pointer"
      @click.stop.prevent="$emit('select-item', label)"
    >
      <div>
        <div class="d-flex justify-content-between">
          <div class="d-flex flex-column">
            <p class="font-weight-bold mb-0">
              {{ getUnitById(label.unitId).name }}

              <i
                v-if="isLocked"
                class="fas fa-lock ml-1"
              />
            </p>
            <small
              v-if="lowerLevelUnit"
              class="d-flex align-items-center"
            >
              <i class="fas fa-arrow-down" />
              {{ lowerLevelUnit.name }}
              {{ childrenLabels.length }}
            </small>
            <small>Scan: {{ label.scanIndex || 'null' }}</small>
            <small>ID: {{ label.id }}</small>
          </div>

          <div>
            <MarkingStatusBadge
              :status="label.labelStatus"
            />
          </div>
          <div>
            <Datamatrix
              :encode-string="label.scanCode"
            />
          </div>
        </div>

        <div
          v-if="childrenLabels.length > 0"
          class="contained-labels"
        >
          <div
            v-for="(containedLabel, innerIndex) in childrenLabels"
            :key="containedLabel.id"
          >
            <MatrioshkaVisualizationColumnLabel
              v-if="getInnerLabel(containedLabel)"
              :index="innerIndex"
              :label="getInnerLabel(containedLabel)"
              :all-labels="allLabels"
              :is-locked="isItemLocked(containedLabel)"
              @select-item="$emit('select-item', $event)"
            />
          </div>
        </div>

        <div
          v-if="noChildren"
          class="contained-labels mb-2"
        >
          No children
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MarkingStatusBadge from '@/components/markings/MarkingStatusBadge.vue';
import Datamatrix from '@/components/dev/Datamatrix.vue';
import { mapGetters } from 'vuex';

export default {
  name: 'MatrioshkaVisualizationColumnLabel',
  props: {
    isLocked: {
      type: Boolean,
      default: false,
    },
    allLabels: {
      type: Array,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
    label: {
      type: Object,
      required: true,
    },
  },
  components: {
    MarkingStatusBadge,
    Datamatrix,
  },
  computed: {
    ...mapGetters('labelArchive', [
      'labelArchiveStatuses',
    ]),
    ...mapGetters('packingSettings', [
      'getUnitById',
      'getLowerLevelUnit',
    ]),
    lowerLevelUnit() {
      return this.getLowerLevelUnit(this.label.unitId, this.label.skuId);
    },
    childrenLabels() {
      return (this.label.containedLabels || [])
        .filter(l => l.unitId === this.lowerLevelUnit.id);
    },
    noChildren() {
      return this.childrenLabels.length === 0 && this.lowerLevelUnit;
    },
  },
  methods: {
    statusColor(s) {
      const status = this.labelArchiveStatuses.find(st => st.id === s);
      return status?.color || '#171717';
    },
    getInnerLabel(containedLabel) {
      return this.allLabels.find(l => l.id === containedLabel.id) || null;
    },
    isItemLocked(item) {
      const relation = this.label.containedLabels.find(r => r.id === item.id);
      return relation?.locked;
    },
  },
};
</script>

<style scoped lang="scss">

  .label {
    width: 270px;
    padding: 6px;
    background: #e8e8e8;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.5) inset;

    .contained-labels {
      margin: -15px -15px -15px 0px;
      margin-top: 5px;
      display: flex;
      flex-wrap: wrap;
      border-radius: 10px;
      scale: 0.9;
      opacity: 0.9;

      &:hover {
        opacity: 1;
        scale: 1;
      }

      &:deep() {
        .label {
          scale: 0.9;
          opacity: 0.9;

          &:hover {
            opacity: 1;
            scale: 1;
            box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.5) inset;
            border: 1px solid #000;
          }
        }
      }
    }
  }

</style>
